(function ($, d, w) {
  const $siteHeader = $('.site-header');
  const $header = $siteHeader.find('.header__container');
  const $mobileHeader = $('#MobileNav');
  const $navigation = $siteHeader.find('.header__desktop-menu__navigation');
  const $mediaMenu = $header.find('.header__desktop-menu__navigation__media');

  if ($siteHeader <= 0 || $header.length <= 0) {
    return false;
  }


  $(d).ready(function () {

    if (!!$mediaMenu == true) {
      $mediaMenu.css('min-height', $navigation.outerHeight());
    }
    /* ======================== Desktop Menu ======================== */
    const $desktopMenu = $header.find('.header__desktop-menu');
    const $firstLevels = $desktopMenu.find('.header__desktop-menu__inline-elements__link');
    const $allDropdown = $desktopMenu.find('.header__desktop-menu__dropdown-wrapper');

    if ($desktopMenu.length > 0) {

      $siteHeader.on('mouseenter', function () {
        $siteHeader.addClass('open');
      });

      $siteHeader.on('mouseleave', function () {
        $siteHeader.removeClass('open');
      });


      $desktopMenu.find('.header__desktop-menu__inline-elements__link').each(function (index, el) {
        let trigger = $(this).find('> span');
        let $dropdownWrapper = $(el).find('.header__desktop-menu__dropdown-wrapper');

        $(trigger).on('mouseenter', function () {
          $firstLevels.removeClass('open');
          if ($allDropdown.length > 0) {
            $allDropdown.removeClass('open');
          }

          $(el).addClass('open');
          $desktopMenu.addClass('open');
          $siteHeader.addClass('open');
          if ($dropdownWrapper.length > 0) {
            $dropdownWrapper.addClass('open');
          }
        });

        $desktopMenu.on('mouseleave', function () {
          $desktopMenu.removeClass('open');
          $(el).removeClass('open');
          if ($dropdownWrapper.length > 0) {
            $dropdownWrapper.removeClass('open');
          }
        });
      });
    }

    if ($mobileHeader.length > 0) {
      $('.mobile-menu-list-group .trigger').click(function (el) {
        if (!$(el.target).closest('.mobile-menu-list-group').hasClass('open')) {
          $('.mobile-menu-list-group').removeClass('open');
          $('.mobile-menu-list-group .mobile-lvl-2').hide();
          $parent = $(el.target).closest('.mobile-menu-list-group').addClass('open');
          $parent.find('.mobile-lvl-2').slideDown();
          $('.mobile-menu-list').addClass('mobile-menu-touched');
        } else {
          $('.mobile-menu-list-group').removeClass('open');
          $('.mobile-menu-list').removeClass('mobile-menu-touched');
          $('.mobile-menu-list-group .mobile-lvl-2').slideUp();
        }
      });
    }
  });
})(jQuery, document, window);